
"use strict";

var dotsRe = /\.+/g;

/**
 * Make a string's first character uppercase 
 *
 * @param {string} string
 * @return {string}
 */

function ucfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Auto-generate column name if not defined
 *
 * @param {Object} column
 * @param {number} index
 * @param {string} [prefix]
 * @return {string}
 */
var autoName = exports.autoName = function(column, index, prefix) {
  var type, name = column.name;

  if ('string' === typeof name && name.length !== 0) {
    return name;
  } else if (!column.args) {
    type = column.type;
    name = column.field;
    if (!type || type === 'group') {
      if ('string' === typeof name && name.length !== 0)
        return name.replace(dotsRe, ' ');
    } else {
      return ('string' === typeof name && name.length !== 0)
              ? ucfirst(type) + ' ' + name.replace(dotsRe, ' ')
              : ucfirst(type);
    }
  }

  return ucfirst((prefix || 'column')) + index;
};

/**
 * Create column name generator
 *
 * @param {string} prefix
 * @param {Object} [uindex]
 * @return {string}
 */
var autoNameGenerator = exports.autoNameGenerator = function(prefix, uindex) {
  uindex || (uindex = {});
  var seq = 0;
  return function next(column) {
    var name = autoName(column, seq++, prefix);
    if (name in uindex) {
      var n = 2, base = name;
      do {
        name = base + n++;
      } while(name in uindex);
    }
    uindex[name] = true;
    return name;
  };
};

/**
 * Determine metric name at index from deep query
 *
 * @param {Object} query
 * @param {number} undex
 * @return {string|undefined}
 */
exports.queryMetricNameFromIndex = function(query, index) {
  var nameGen = autoNameGenerator('metric')
    , metrics = query.metrics
    , len = metrics.length
    , name;

  for(var i = 0; i < len; ++i) {
    name = nameGen(metrics[i])
    if (i === index) return name;
  }
};
